import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadMask from '../../../Utils/LoadMask/LoadMask';
import CardFormulario from '../../../Utils/Cards/cardFormulario';
import GastoForm from './GastoForm';
import moment from 'moment';


class GastoCrear extends Component {
    static propTypes = {
        crear: PropTypes.func.isRequired,
    };
    state ={
        editar: false,
        titulo: 'AGREGAR GASTO',
    }
    componentWillMount(){
        this.props.resetFormulario();
        this.props.getTipoGastos();
        this.props.selectEmpresas();
        this.props.getSelectCuentas()
        if(this.props.match.params.id != null && this.props.match.params.id > 0){
            this.props.leer(this.props.match.params.id)
            this.setState({
                editar:true,
                titulo: 'EDITAR GASTO'
            });
        }
    }
    onSubmit = (values) =>{
        const {crear, editar} =this.props
        let id = this.props.match.params.id
        let valores_formulario = _.cloneDeep(values)

        try {if (values.tipo_gasto && values.tipo_gasto.value) valores_formulario.tipo_gasto = values.tipo_gasto.value;}
        catch (e) {if (values.tipo_gasto) valores_formulario.tipo_gasto = values.tipo_gasto;}
        if(valores_formulario && valores_formulario.cliente){
            valores_formulario.cliente = valores_formulario.cliente.id
        }
        if(valores_formulario && valores_formulario.trabajador){
            valores_formulario.trabajador = valores_formulario.trabajador.id
        }
        if(valores_formulario && valores_formulario.proveedor){
            valores_formulario.proveedor = valores_formulario.proveedor.id
        }
        if(valores_formulario && valores_formulario.fecha_servicio){
            valores_formulario.fecha_servicio = moment(valores_formulario.fecha_servicio).format("YYYY-MM-DD");
        }
        valores_formulario.fecha = moment(valores_formulario.fecha).format('YYYY-MM-DD')
        if (typeof valores_formulario.tipo_documento == 'undefined') {
            valores_formulario.tipo_documento = null
        }
        if (valores_formulario.pendiente_liquidar) {
            valores_formulario.desglose = [];
        }

        this.state.editar? editar(id,valores_formulario) : crear(valores_formulario);
    }
    render() {
        const { loader, empresas, select_cuentas, cambioDescuento } = this.props;

        return (
            <CardFormulario titulo={this.state.titulo}>
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <GastoForm
                        empresas={empresas}
                        select_cuentas={select_cuentas}
                        initialValues={{
                            desglose:[{}],
                            tipo_cuenta:"false",
                            fecha: new Date(),
                            pendiente_liquidar:false,
                            fecha_servicio: new Date(),
                        }}
                        editar={this.state.editar}
                        cambioDescuento={cambioDescuento}
                        tipo_gastos={this.props.tipo_gastos}
                        tipo_gasto = {this.props.item}
                        onSubmit={this.onSubmit}
                        permisos={this.props.permisos}
                        id_user={this.props.id_user}/>
                </LoadMask>
            </CardFormulario>
        );
    }
}
export default GastoCrear;
